import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-EH-logo_svg__svg5690",
  viewBox: "0 0 298 75.99"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-EH-logo_svg__cls-2{fill:#223f9a}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      id: "svg-EH-logo_svg__path5697",
      d: "M285.79 0 241.9 75.99h12.22L298 0h-12.21Z",
      style: {"fill":"#00b3f0"}
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      id: "svg-EH-logo_svg__path5699",
      d: "M241.9 75.99 285.8 0h-48.83l-43.88 75.99h48.82Z",
      class: "svg-EH-logo_svg__cls-2"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("g", { id: "svg-EH-logo_svg__g5701" }, [
      _createElementVNode("path", {
        id: "svg-EH-logo_svg__path5703",
        d: "M85.05 25.31c.12-.61.7-1.11 1.36-1.11.58 0 1.13.44 1.32.95l13.95 50.83h22.86l11.65-66.06h-10.07l-8.96 50.86c-.12.64-.65 1.14-1.33 1.14-.62 0-1.15-.45-1.31-1.02L100.54 9.91H77.69L66.05 75.97H76.1l8.95-50.67M46.02 53.59l-1.95-29.6c-.02-.66-.46-1.28-1.11-1.46-.73-.18-1.47.2-1.76.85l-29.81 52.6H0L37.44 9.92h22.01l4.4 66.06H47.51l-.48-7.2c-.08-1.54-1.23-2.76-2.76-2.76H19.56l5.57-9.85h18.53c1.35 0 2.45-1.19 2.35-2.58m124.22.14-2.6-29.32c-.07-.77-.7-1.35-1.49-1.35-.53 0-1 .27-1.27.69l-26.83 52.24h-11.13l33.9-66.07h22.01l5.86 66.06h-16.46l-.64-7.2c-.12-1.55-1.24-2.75-2.76-2.75h-23.17l5.06-9.86h17.17c1.4 0 2.51-1.21 2.37-2.44",
        class: "svg-EH-logo_svg__cls-2"
      })
    ], -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "EH-logo"}) } }